import { userConstants } from './../constants/user.constants';

const initialState = {};

export function LoansCount(state = initialState, action) {
  switch (action.type) {
    case userConstants.LOANCOUNT_REQUEST:
      return {
        user: action.user,
        isLoading : true

      };
    case userConstants.LOANCOUNT_SUCCESS:
      const {res} = action
        
      return {
        res,
        isLoading : false
      };
    case userConstants.LOANCOUNT_FAILURE:
      return {
        isLoading : false
      };
    default:
      return state
  }
}